/* ============================================================================
 * Construction Solution Center B.V. — front-end app (mock). Depends on mb-data.js (window.MB).
 * Handles: i18n + language toggle, cart drawer, hero carousel, most-sold
 * slider, product grid + category filter, product detail page, contact forms.
 * ==========================================================================*/
(function () {
  'use strict';
  var MB = window.MB || (window.MB = {});
  var LS_LANG = 'mb_lang', LS_CART = 'mb_cart', LS_VISITED = 'mb_visited';

  MB.routes = Object.assign(
    { product: '/pages/product', home: '/', shop: '/#mb-shop' },
    window.MB_ROUTES || {}
  );

  var state = {
    lang: localStorage.getItem(LS_LANG) || ((navigator.language || '').slice(0, 2) === 'nl' ? 'nl' : 'en'),
    cart: readCart(),
    filter: 'all'
  };
  if (!MB.i18n[state.lang]) state.lang = 'en';

  /* ---------- helpers ---------------------------------------------------- */
  function t(key) {
    var d = MB.i18n[state.lang] || {};
    return (key in d) ? d[key] : (MB.i18n.en[key] != null ? MB.i18n.en[key] : key);
  }
  function loc(obj) { return obj ? (obj[state.lang] || obj.en) : ''; }
  function money(v) {
    if (v == null) return '';
    if (state.lang === 'nl') return MB.currency + ' ' + v.toFixed(2).replace('.', ',');
    return MB.currency + ' ' + v.toFixed(2);
  }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function qs(name) { return new URLSearchParams(location.search).get(name); }
  function byId(id) { return MB.products.filter(function (p) { return p.id === +id; })[0]; }
  function readCart() { try { return JSON.parse(localStorage.getItem(LS_CART)) || []; } catch (e) { return []; } }
  function saveCart() { localStorage.setItem(LS_CART, JSON.stringify(state.cart)); }
  function categoryLabel(cat) {
    var key = 'filter.' + cat;
    var translated = t(key);
    return translated !== key ? translated : cat;
  }
  var SWATCHES = { Anthracite: '#3a3f45', White: '#ffffff', Cream: '#efe7d6', Black: '#1a1a1a', Grey: '#9aa0a8', Silver: '#c9ccd1', Steel: '#8b9096', Zinc: '#b8bcc2', Nickel: '#c4c8cc', Blue: '#2f6fb0', Clear: '#e8eef5', Mixed: 'linear-gradient(135deg,#e8620c,#3a3f45)' };

  /* ---------- i18n application ------------------------------------------ */
  function applyI18n(root) {
    root = root || document;
    root.querySelectorAll('[data-i18n]').forEach(function (n) { n.textContent = t(n.getAttribute('data-i18n')); });
    root.querySelectorAll('[data-i18n-ph]').forEach(function (n) { n.setAttribute('placeholder', t(n.getAttribute('data-i18n-ph'))); });
    root.querySelectorAll('[data-i18n-html]').forEach(function (n) { n.innerHTML = t(n.getAttribute('data-i18n-html')); });
    var toggle = document.getElementById('mb-lang-toggle');
    if (toggle) toggle.checked = state.lang === 'nl';
    document.documentElement.setAttribute('lang', state.lang);
  }

  function setLang(lang) {
    if (!MB.i18n[lang]) return;
    state.lang = lang;
    localStorage.setItem(LS_LANG, lang);
    renderAll();
  }

  /* ---------- render orchestrator --------------------------------------- */
  function renderAll() {
    applyI18n(document);
    if (document.getElementById('mb-hero')) renderHero();
    if (document.getElementById('mb-mostsold')) renderMostSold();
    if (document.getElementById('mb-grid')) renderGrid();
    if (document.getElementById('mb-pdp')) renderPDP();
    if (document.getElementById('mb-about')) renderAbout();
    if (document.getElementById('mb-faq')) renderFaq();
    applyI18n(document);
    renderCart();
    if (document.querySelector('cart-drawer')) syncShopifyCartCount();
    else updateCartCount();
    overrideDawnButtons();
    overrideDawnDescription();
    overrideDawnCartDrawer();
  }

  var FALLBACK_IMG = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect fill="#f5f6f8" width="400" height="400"/><g transform="translate(200,170)" fill="none" stroke="#8a929e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="-30" y="-24" width="60" height="48" rx="4"/><circle cx="-14" cy="-10" r="5"/><polyline points="-30,24 -6,-4 6,10 18,-2 30,24"/></g><text x="200" y="240" text-anchor="middle" fill="#8a929e" font-family="sans-serif" font-size="13">Image not available</text></svg>');
  function productImg(p, i) { return (p.images && p.images.length) ? p.images[i || 0] : FALLBACK_IMG; }

  /* ---------- product card ---------------------------------------------- */
  function cardHTML(p) {
    var out = p.stock <= 0;
    var sale = p.compareAt && p.compareAt > p.price && !out;
    var badge = '';
    if (out) badge = '<span class="mb-card__badge mb-card__badge--out">' + t('card.out') + '</span>';
    else if (sale) {
      var pct = Math.round((1 - p.price / p.compareAt) * 100);
      badge = '<span class="mb-card__badge">-' + pct + '%</span>';
    }
    var price = sale
      ? '<span class="mb-price mb-price--sale">' + money(p.price) + '</span><span class="mb-price--old">' + money(p.compareAt) + '</span>'
      : '<span class="mb-price">' + money(p.price) + '</span>';
    return (
      '<a class="mb-card" href="/products/' + p.handle + '">' +
        '<div class="mb-card__media">' + badge +
          '<img loading="lazy" src="' + productImg(p) + '" alt="' + esc(loc(p.name)) + '">' +
        '</div>' +
        '<div class="mb-card__body">' +
          '<span class="mb-card__cat">' + esc(p.productType || '') + '</span>' +
          '<span class="mb-card__title">' + esc(loc(p.name)) + '</span>' +
          '<span class="mb-card__desc">' + esc(loc(p.description)) + '</span>' +
          '<span class="mb-card__foot">' + price + '</span>' +
        '</div>' +
      '</a>'
    );
  }

  /* ---------- HERO carousel --------------------------------------------- */
  var HERO = [
    { img: 'https://cdn.shopify.com/s/files/1/1095/2284/6034/files/render_263407a0-1bdc-418d-9ddd-9722e48e3766.jpg?v=1785928343', k: 'hero.slide1' },
    { img: 'https://cdn.shopify.com/s/files/1/1095/2284/6034/files/render_72d95ea1-8e05-41f0-93be-f8acfcf865a7.jpg?v=1785928343', k: 'hero.slide2' },
    { img: 'https://cdn.shopify.com/s/files/1/1095/2284/6034/files/render_cab1930f-c19c-4379-8dbc-9439a54da582.jpg?v=1785928343', k: 'hero.slide3' },
    { img: 'https://cdn.shopify.com/s/files/1/1095/2284/6034/files/render_24d8919f-4077-4685-947a-dbbc9593f773.jpg?v=1785928343', k: 'hero.slide4' }
  ];
  var heroTimer = null, heroIndex = 0;
  function renderHero() {
    var root = document.getElementById('mb-hero');
    var slides = HERO.map(function (s) {
      return (
        '<div class="mb-hero__slide">' +
          '<img src="' + s.img + '" alt="' + esc(t(s.k + '.title')) + '">' +
          '<div class="mb-hero__overlay"><div class="mb-hero__content"><div class="mb-hero__inner">' +
            '<div class="mb-hero__eyebrow">Construction Solution Center B.V.</div>' +
            '<h1 class="mb-hero__title">' + esc(t(s.k + '.title')) + '</h1>' +
            '<p class="mb-hero__text">' + esc(t(s.k + '.text')) + '</p>' +
            '<a class="mb-btn" href="' + MB.routes.shop + '">' + esc(t('hero.cta')) + '</a>' +
          '</div></div></div>' +
        '</div>'
      );
    }).join('');
    var dots = HERO.map(function (_, i) { return '<button data-i="' + i + '" aria-label="slide ' + (i + 1) + '"></button>'; }).join('');
    root.innerHTML =
      '<div class="mb-hero__viewport">' +
        '<div class="mb-hero__track" id="mb-hero-track">' + slides + '</div>' +
        '<button class="mb-hero__arrow mb-hero__arrow--prev" aria-label="Previous">' + icon('chevL') + '</button>' +
        '<button class="mb-hero__arrow mb-hero__arrow--next" aria-label="Next">' + icon('chevR') + '</button>' +
        '<div class="mb-hero__dots" id="mb-hero-dots">' + dots + '</div>' +
      '</div>';

    var track = root.querySelector('#mb-hero-track');
    function go(i) {
      heroIndex = (i + HERO.length) % HERO.length;
      track.style.transform = 'translateX(' + (-heroIndex * 100) + '%)';
      root.querySelectorAll('#mb-hero-dots button').forEach(function (b, bi) { b.classList.toggle('is-active', bi === heroIndex); });
    }
    function auto() { clearInterval(heroTimer); heroTimer = setInterval(function () { go(heroIndex + 1); }, 6000); }
    root.querySelector('.mb-hero__arrow--prev').onclick = function () { go(heroIndex - 1); auto(); };
    root.querySelector('.mb-hero__arrow--next').onclick = function () { go(heroIndex + 1); auto(); };
    root.querySelectorAll('#mb-hero-dots button').forEach(function (b) { b.onclick = function () { go(+b.getAttribute('data-i')); auto(); }; });
    go(heroIndex); auto();
  }

  /* ---------- MOST SOLD slider ------------------------------------------ */
  function renderMostSold() {
    var root = document.getElementById('mb-mostsold');
    var top = MB.products.filter(function (p) { return p.stock > 0; }).slice(0, 10);
    if (top.length < 10) top = MB.products.slice(0, 10);
    root.innerHTML =
      '<div class="mb-wrap">' +
        '<div class="mb-slider__head">' +
          '<div>' +
            '<div class="mb-eyebrow" data-i18n="mostsold.subtitle"></div>' +
            '<h2 class="mb-h2" data-i18n="mostsold.title"></h2>' +
          '</div>' +
          '<div class="mb-slider__arrows">' +
            '<button class="mb-arrow" id="ms-prev" aria-label="Previous">' + icon('chevL') + '</button>' +
            '<button class="mb-arrow" id="ms-next" aria-label="Next">' + icon('chevR') + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="mb-slider__viewport"><div class="mb-slider__track" id="ms-track">' +
          top.map(cardHTML).join('') +
        '</div></div>' +
      '</div>';
    applyI18n(root);
    setupSlider(root.querySelector('#ms-track'), root.querySelector('#ms-prev'), root.querySelector('#ms-next'), 5);
  }

  function setupSlider(track, prev, next, visible) {
    var offset = 0;
    function metrics() {
      var first = track.children[0];
      if (!first) return { step: 0, max: 0 };
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 20) || 20;
      var step = first.getBoundingClientRect().width + gap;
      var vp = track.parentElement.getBoundingClientRect().width;
      var vis = Math.max(1, Math.round(vp / step));
      return { step: step, max: Math.max(0, track.children.length - vis) };
    }
    function apply() {
      var m = metrics();
      offset = Math.min(offset, m.max); if (offset < 0) offset = 0;
      track.style.transform = 'translateX(' + (-offset * m.step) + 'px)';
      prev.disabled = offset <= 0; next.disabled = offset >= m.max;
    }
    prev.onclick = function () { offset = Math.max(0, offset - visible); apply(); };
    next.onclick = function () { offset += visible; apply(); };
    window.addEventListener('resize', apply);
    apply();
  }

  /* ---------- PRODUCT GRID + FILTER ------------------------------------- */
  function getProductCategories() {
    var seen = {};
    MB.products.forEach(function (p) {
      if (p.productType && p.productType !== '') seen[p.productType] = true;
    });
    return Object.keys(seen).sort();
  }

  function renderGrid() {
    var root = document.getElementById('mb-grid');
    var cats = ['all'].concat(getProductCategories());
    var filters = cats.map(function (c) {
      var label = c === 'all' ? t('filter.all') : c;
      return '<button class="mb-filter' + (state.filter === c ? ' is-active' : '') + '" data-cat="' + c + '">' + esc(label) + '</button>';
    }).join('');
    var list = MB.products.filter(function (p) {
      if (state.filter === 'all') return true;
      return p.productType === state.filter;
    });
    root.innerHTML =
      '<div class="mb-filters" id="mb-filters">' + filters + '</div>' +
      '<div class="mb-grid" id="mb-grid-items">' + list.map(cardHTML).join('') + '</div>';
    applyI18n(root);
    root.querySelectorAll('.mb-filter').forEach(function (b) {
      b.onclick = function () { state.filter = b.getAttribute('data-cat'); renderGrid(); };
    });
  }

  /* ---------- PRODUCT DETAIL PAGE --------------------------------------- */
  var pdpState = { img: 0, color: 0, size: 0, qty: 1 };
  function renderPDP() {
    var root = document.getElementById('mb-pdp');
    var p = byId(qs('id'));
    if (!p) { root.innerHTML = '<div class="mb-wrap mb-section"><p>' + t('pdp.notfound') + '</p><a class="mb-btn" href="' + MB.routes.shop + '">' + t('pdp.back') + '</a></div>'; return; }
    document.title = loc(p.name) + ' — Construction Solution Center B.V.';
    var out = p.stock <= 0;
    var sale = p.compareAt && p.compareAt > p.price && !out;
    var priceHTML = sale
      ? '<span class="mb-price mb-price--sale">' + money(p.price) + '</span><span class="mb-price--old">' + money(p.compareAt) + '</span>'
      : '<span class="mb-price">' + money(p.price) + '</span>';
    var pdpImages = (p.images && p.images.length) ? p.images : [FALLBACK_IMG];
    var thumbs = pdpImages.map(function (im, i) {
      return '<button class="mb-gallery__thumb' + (i === pdpState.img ? ' is-active' : '') + '" data-i="' + i + '"><img src="' + im + '" alt=""></button>';
    }).join('');
    var colorOpts = p.colors.map(function (c, i) {
      var sw = SWATCHES[c] || '#ccc';
      return '<button class="mb-opt' + (i === pdpState.color ? ' is-active' : '') + '" data-color="' + i + '"><span class="mb-swatch"><i style="background:' + sw + '"></i>' + esc(c) + '</span></button>';
    }).join('');
    var sizeOpts = p.sizes.map(function (s, i) {
      return '<button class="mb-opt' + (i === pdpState.size ? ' is-active' : '') + '" data-size="' + i + '">' + esc(s) + '</button>';
    }).join('');

    root.innerHTML =
      '<div class="mb-wrap mb-section">' +
      '<a class="mb-pdp__back" href="' + MB.routes.shop + '">' + icon('chevL') + '<span data-i18n="pdp.back"></span></a>' +
      '<div class="mb-pdp">' +
        '<div class="mb-gallery">' +
          '<div class="mb-gallery__main">' +
            '<img id="pdp-main" src="' + pdpImages[pdpState.img] + '" alt="' + esc(loc(p.name)) + '">' +
            '<button class="mb-gallery__arrow mb-gallery__arrow--prev" id="pdp-prev">' + icon('chevL') + '</button>' +
            '<button class="mb-gallery__arrow mb-gallery__arrow--next" id="pdp-next">' + icon('chevR') + '</button>' +
          '</div>' +
          '<div class="mb-gallery__thumbs" id="pdp-thumbs">' + thumbs + '</div>' +
        '</div>' +
        '<div class="mb-pdp__info">' +
          '<div class="mb-pdp__cat">' + esc(p.productType || '') + '</div>' +
          '<h1 class="mb-pdp__title">' + esc(loc(p.name)) + '</h1>' +
          '<div class="mb-pdp__price">' + priceHTML + '</div>' +
          '<p class="mb-pdp__desc">' + esc(loc(p.description)) + '</p>' +
          '<div class="mb-pdp__stock">' +
            (out
              ? '<span class="mb-dot mb-dot--out"></span><span>' + t('pdp.outofstock') + '</span>'
              : '<span class="mb-dot"></span><span>' + t('pdp.stock') + '</span><span class="mb-pdp__sep">·</span><span>' + t('pdp.delivery') + '</span><span class="mb-pdp__sep">·</span><span>' + t('pdp.secure') + '</span>') +
          '</div>' +
          '<div class="mb-field"><span class="mb-field__label" data-i18n="pdp.color"></span><div class="mb-opts" id="pdp-colors">' + colorOpts + '</div></div>' +
          '<div class="mb-field"><span class="mb-field__label" data-i18n="pdp.size"></span><div class="mb-opts" id="pdp-sizes">' + sizeOpts + '</div></div>' +
          '<div class="mb-field"><span class="mb-field__label" data-i18n="pdp.qty"></span>' +
            '<div class="mb-buyrow">' +
              '<div class="mb-qty">' +
                '<button id="pdp-minus" aria-label="minus">−</button>' +
                '<input id="pdp-qty" type="number" min="1" value="' + pdpState.qty + '">' +
                '<button id="pdp-plus" aria-label="plus">+</button>' +
              '</div>' +
              '<button class="mb-btn mb-btn--block" id="pdp-add"' + (out ? ' disabled' : '') + '>' + icon('cart') + '<span data-i18n="pdp.add"></span></button>' +
            '</div>' +
          '</div>' +
          '<div class="mb-pdp__meta">' +
            '<div><b data-i18n="pdp.sku"></b>: ' + p.sku + '</div>' +
            '<div><b data-i18n="pdp.category"></b>: ' + esc(p.productType || '') + '</div>' +
          '</div>' +
        '</div>' +
      '</div></div>';
    applyI18n(root);

    var main = root.querySelector('#pdp-main');
    function setImg(i) { pdpState.img = (i + pdpImages.length) % pdpImages.length; main.src = pdpImages[pdpState.img]; root.querySelectorAll('#pdp-thumbs .mb-gallery__thumb').forEach(function (b, bi) { b.classList.toggle('is-active', bi === pdpState.img); }); }
    root.querySelector('#pdp-prev').onclick = function () { setImg(pdpState.img - 1); };
    root.querySelector('#pdp-next').onclick = function () { setImg(pdpState.img + 1); };
    root.querySelectorAll('#pdp-thumbs .mb-gallery__thumb').forEach(function (b) { b.onclick = function () { setImg(+b.getAttribute('data-i')); }; });
    root.querySelectorAll('#pdp-colors .mb-opt').forEach(function (b) { b.onclick = function () { pdpState.color = +b.getAttribute('data-color'); root.querySelectorAll('#pdp-colors .mb-opt').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); }; });
    root.querySelectorAll('#pdp-sizes .mb-opt').forEach(function (b) { b.onclick = function () { pdpState.size = +b.getAttribute('data-size'); root.querySelectorAll('#pdp-sizes .mb-opt').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); }; });
    var qtyInput = root.querySelector('#pdp-qty');
    root.querySelector('#pdp-minus').onclick = function () { qtyInput.value = Math.max(1, (+qtyInput.value || 1) - 1); pdpState.qty = +qtyInput.value; };
    root.querySelector('#pdp-plus').onclick = function () { qtyInput.value = (+qtyInput.value || 1) + 1; pdpState.qty = +qtyInput.value; };
    qtyInput.oninput = function () { pdpState.qty = Math.max(1, +qtyInput.value || 1); };
    if (!out) root.querySelector('#pdp-add').onclick = function () {
      addToCart(p, { color: p.colors[pdpState.color], size: p.sizes[pdpState.size], qty: pdpState.qty });
      openCart();
    };
  }

  /* ---------- CART ------------------------------------------------------ */
  function addToCart(p, opt) {
    var key = p.id + '|' + (opt.color || '') + '|' + (opt.size || '');
    var line = state.cart.filter(function (l) { return l.key === key; })[0];
    if (line) line.qty += opt.qty; else state.cart.push({ key: key, id: p.id, color: opt.color, size: opt.size, qty: opt.qty });
    saveCart(); renderCart(); updateCartCount();
  }
  function changeLineQty(key, delta) {
    var line = state.cart.filter(function (l) { return l.key === key; })[0];
    if (!line) return;
    line.qty = Math.max(0, line.qty + delta);
    saveCart(); renderCart(); updateCartCount();
  }
  function cartTotal() { return state.cart.reduce(function (s, l) { var p = byId(l.id); return s + (p ? p.price * l.qty : 0); }, 0); }
  function updateCartCount() {
    if (document.querySelector('cart-drawer')) { syncShopifyCartCount(); return; }
    var n = state.cart.reduce(function (s, l) { return s + l.qty; }, 0);
    document.querySelectorAll('.mb-cart-count').forEach(function (c) { c.textContent = n; c.style.display = n ? 'flex' : 'none'; });
  }
  function renderCart() {
    var body = document.getElementById('mb-cart-body');
    if (!body) return;
    if (!state.cart.length) { body.innerHTML = '<div class="mb-drawer__empty">' + t('cart.empty') + '</div>'; }
    else {
      body.innerHTML = state.cart.map(function (l) {
        var p = byId(l.id); if (!p) return '';
        var vparts = [l.color, l.size].filter(Boolean).join(' · ');
        var zeroClass = l.qty === 0 ? ' mb-line__qty--zero' : '';
        return '<div class="mb-line' + (l.qty === 0 ? ' mb-line--zero' : '') + '">' +
          '<img src="' + productImg(p) + '" alt="">' +
          '<div class="mb-line__info">' +
            '<div class="mb-line__name">' + esc(loc(p.name)) + '</div>' +
            (vparts ? '<div class="mb-line__var">' + esc(vparts) + '</div>' : '') +
            '<div class="mb-line__price">' + money(p.price * l.qty) + '</div>' +
            '<div class="mb-line__qty' + zeroClass + '">' +
              '<button data-key="' + l.key + '" data-delta="-1" aria-label="decrease">−</button>' +
              '<span>' + l.qty + '</span>' +
              '<button data-key="' + l.key + '" data-delta="1" aria-label="increase">+</button>' +
            '</div>' +
          '</div></div>';
      }).join('');
      body.querySelectorAll('.mb-line__qty button').forEach(function (b) {
        b.onclick = function () { changeLineQty(b.getAttribute('data-key'), +b.getAttribute('data-delta')); };
      });
    }
    var total = cartTotal();
    var btw = total * 0.21;
    var sub = document.getElementById('mb-cart-subtotal');
    if (sub) sub.textContent = money(total);
    var btwEl = document.getElementById('mb-cart-btw');
    if (btwEl) btwEl.textContent = money(btw);
    var totalEl = document.getElementById('mb-cart-total');
    if (totalEl) totalEl.textContent = money(total + btw);
    var fields = document.getElementById('mb-cart-fields');
    if (fields) fields.style.display = state.cart.length ? 'grid' : 'none';
  }
  function purgeZeroLines() { state.cart = state.cart.filter(function (l) { return l.qty > 0; }); saveCart(); }
  function openCart() { var o = document.getElementById('mb-cart-overlay'), d = document.getElementById('mb-cart'); if (o) o.classList.add('is-open'); if (d) d.classList.add('is-open'); }
  function closeCart() {
    var o = document.getElementById('mb-cart-overlay'), d = document.getElementById('mb-cart');
    if (o) o.classList.remove('is-open'); if (d) d.classList.remove('is-open');
    purgeZeroLines(); renderCart(); updateCartCount();
  }


  /* ---------- ABOUT + FAQ ----------------------------------------------- */
  function renderAbout() {
    var root = document.getElementById('mb-about');
    root.innerHTML =
      '<div class="mb-wrap mb-section"><div class="mb-eyebrow">Construction Solutions B.V.</div>' +
      '<h1 class="mb-h2" data-i18n="about.title"></h1>' +
      '<div class="mb-prose">' + (MB.pages.about[state.lang] || MB.pages.about.en) + '</div></div>';
    applyI18n(root);
  }
  function renderFaq() {
    var root = document.getElementById('mb-faq');
    var items = (MB.pages.faq[state.lang] || MB.pages.faq.en);
    root.innerHTML =
      '<div class="mb-wrap mb-section"><div class="mb-eyebrow">FAQ</div>' +
      '<h1 class="mb-h2" data-i18n="faq.title"></h1>' +
      '<div class="mb-accordion">' + items.map(function (qa, i) {
        return '<div class="mb-acc' + (i === 0 ? ' is-open' : '') + '">' +
          '<button class="mb-acc__q">' + esc(qa[0]) + '<i>+</i></button>' +
          '<div class="mb-acc__a"><p>' + esc(qa[1]) + '</p></div></div>';
      }).join('') + '</div></div>';
    applyI18n(root);
    root.querySelectorAll('.mb-acc').forEach(function (acc) {
      var a = acc.querySelector('.mb-acc__a');
      if (acc.classList.contains('is-open')) a.style.maxHeight = a.scrollHeight + 'px';
      acc.querySelector('.mb-acc__q').onclick = function () {
        var open = acc.classList.toggle('is-open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      };
    });
  }

  /* ---------- CONTACT FORMS --------------------------------------------- */
  function initForms() {
    document.querySelectorAll('.mb-form[data-mbform]').forEach(function (form) {
      // file preview
      var file = form.querySelector('input[type=file]');
      if (file) {
        var drop = file.closest('.mb-file');
        var prev = form.querySelector('.mb-file__preview');
        var hint = drop.querySelector('span[data-i18n]');
        drop.addEventListener('click', function (e) {
          if (e.target.closest('.mb-file__remove')) return;
          file.click();
        });
        file.addEventListener('change', function () {
          if (file.files && file.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
              prev.innerHTML = '<img src="' + e.target.result + '" alt="preview"><button type="button" class="mb-file__remove" aria-label="Remove">&times;</button>';
              if (hint) hint.style.display = 'none';
              prev.querySelector('.mb-file__remove').addEventListener('click', function (ev) {
                ev.stopPropagation();
                ev.preventDefault();
                file.value = '';
                prev.innerHTML = '';
                if (hint) hint.style.display = '';
              });
            };
            reader.readAsDataURL(file.files[0]);
          }
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var ok = true;
        form.querySelectorAll('[required]').forEach(function (fld) {
          var err = fld.closest('.mb-field').querySelector('.mb-error');
          var empty = fld.type === 'file' ? !(fld.files && fld.files.length) : !fld.value.trim();
          if (empty) { ok = false; if (err) err.classList.add('is-show'); }
          else if (err) err.classList.remove('is-show');
        });
        if (!ok) return;
        var note = form.querySelector('.mb-note');
        if (note) note.classList.add('is-show');
        form.reset();
        var prev = form.querySelector('.mb-file__preview'); if (prev) prev.innerHTML = '';
        setTimeout(function () { if (note) note.classList.remove('is-show'); }, 6000);
      });
    });
  }

  /* ---------- Shopify cart badge sync ----------------------------------- */
  function syncShopifyCartCount() {
    fetch('/cart.json').then(function (r) { return r.json(); }).then(function (data) {
      var n = data.item_count || 0;
      document.querySelectorAll('.mb-cart-count').forEach(function (c) { c.textContent = n; c.style.display = n ? 'flex' : 'none'; });
    }).catch(function () {});
  }

  /* ---------- header interactions --------------------------------------- */
  function initHeader() {
    var toggle = document.getElementById('mb-lang-toggle');
    if (toggle) toggle.onchange = function () { setLang(toggle.checked ? 'nl' : 'en'); };
    var dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer) {
      document.querySelectorAll('[data-mb-cart-open]').forEach(function (b) {
        b.onclick = function (e) { e.preventDefault(); dawnDrawer.open(b); };
      });
      syncShopifyCartCount();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, syncShopifyCartCount);
        subscribe(PUB_SUB_EVENTS.cartError, syncShopifyCartCount);
      }
    } else {
      document.querySelectorAll('[data-mb-cart-open]').forEach(function (b) { b.onclick = function (e) { e.preventDefault(); openCart(); }; });
    }
    var o = document.getElementById('mb-cart-overlay'); if (o) o.onclick = closeCart;
    var c = document.getElementById('mb-cart-close'); if (c) c.onclick = closeCart;
    // mobile nav
    var nav = document.getElementById('mb-mobilenav');
    document.querySelectorAll('[data-mb-burger]').forEach(function (b) { b.onclick = function () { if (nav) nav.classList.add('is-open'); }; });
    var mc = document.getElementById('mb-mobilenav-close'); if (mc && nav) mc.onclick = function () { nav.classList.remove('is-open'); };
    // active nav link
    var path = location.pathname;
    document.querySelectorAll('.mb-nav > a, .mb-mobilenav > a').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href && href !== '/' && path.indexOf(href) === 0) a.classList.add('is-active');
      if (href === '/' && (path === '/' || path === '')) a.classList.add('is-active');
    });

    // categories dropdown nav links
    document.querySelectorAll('[data-mb-cat]').forEach(function (a) {
      a.onclick = function (e) {
        var cat = a.getAttribute('data-mb-cat');
        state.filter = cat;
        var grid = document.getElementById('mb-grid');
        if (grid) {
          renderGrid();
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        var mobileNav = document.getElementById('mb-mobilenav');
        if (mobileNav) mobileNav.classList.remove('is-open');
      };
    });

    // account dropdown (logged-in user)
    var accountDrop = document.getElementById('mb-account-drop');
    var accountBtn = document.querySelector('[data-mb-account-toggle]');
    if (accountBtn && accountDrop) {
      accountBtn.onclick = function (e) {
        e.stopPropagation();
        accountDrop.classList.toggle('is-open');
      };
      document.addEventListener('click', function (e) {
        if (!accountDrop.contains(e.target)) accountDrop.classList.remove('is-open');
      });
    }

  }

  /* ---------- icons ------------------------------------------------------ */
  function icon(name) {
    var i = {
      chevL: '<path d="M15 18l-6-6 6-6"/>',
      chevR: '<path d="M9 18l6-6-6-6"/>',
      cart: '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/>',
      menu: '<path d="M3 12h18M3 6h18M3 18h18"/>',
      search: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>'
    }[name] || '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + i + '</svg>';
  }
  MB.icon = icon;

  /* ---------- back to top ------------------------------------------------ */
  function initBackToTop() {
    var btn = document.getElementById('mb-btt');
    if (!btn) return;
    var footer = document.querySelector('.mb-footer');
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 400);
      if (footer) {
        var footerTop = footer.getBoundingClientRect().top;
        var viewH = window.innerHeight;
        if (footerTop < viewH) {
          btn.style.bottom = (viewH - footerTop + 16) + 'px';
        } else {
          btn.style.bottom = '28px';
        }
      }
    }, { passive: true });
    btn.onclick = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
  }

  /* ---------- company / personal toggle -------------------------------- */
  function initRegToggle() {
    var btns = document.querySelectorAll('.mb-reg-type__btn');
    var companyBlock = document.getElementById('mb-reg-company');
    if (!btns.length || !companyBlock) return;
    btns.forEach(function (b) {
      b.onclick = function () {
        btns.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        companyBlock.style.display = b.getAttribute('data-reg') === 'company' ? 'block' : 'none';
        var fields = companyBlock.querySelectorAll('input');
        fields.forEach(function (f) {
          if (b.getAttribute('data-reg') === 'company') f.setAttribute('required', '');
          else f.removeAttribute('required');
        });
      };
    });
  }

  /* ---------- Dawn price change animation ------------------------------ */
  function initPriceAnimation() {
    var priceContainer = document.querySelector('.price');
    if (!priceContainer) return;
    var observer = new MutationObserver(function () {
      priceContainer.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (el) {
        el.classList.remove('mb-price-changed');
        void el.offsetWidth;
        el.classList.add('mb-price-changed');
      });
    });
    observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Dawn button text override -------------------------------- */
  function overrideDawnButtons() {
    var map = {
      'Add to cart': 'dawn.add_to_cart', 'Aan winkelwagen toevoegen': 'dawn.add_to_cart',
      'Sold out': 'dawn.sold_out', 'Uitverkocht': 'dawn.sold_out',
      'Tax included.': 'dawn.tax_included', 'Belastingen inbegrepen.': 'dawn.tax_included',
      'More payment options': 'dawn.more_payment', 'Meer betalingsopties': 'dawn.more_payment',
      'Share': 'dawn.share', 'Delen': 'dawn.share',
      'Quantity': 'dawn.quantity', 'Aantal': 'dawn.quantity',
      'Buy with': 'dawn.buy_with', 'Kopen met': 'dawn.buy_with',
      'Maat': 'dawn.size', 'Size': 'dawn.size',
      'Description': 'dawn.description', 'Beschrijving': 'dawn.description',
      'Variant uitverkocht of niet beschikbaar': 'dawn.variant_soldout',
      'Variant sold out or unavailable': 'dawn.variant_soldout',
      'Verzendkosten': 'dawn.shipping', 'Shipping': 'dawn.shipping',
      'Normale prijs': 'dawn.normal_price', 'Regular price': 'dawn.normal_price',
      'Aanbiedingsprijs': 'dawn.sale_price', 'Sale price': 'dawn.sale_price',
      'Back to products': 'dawn.back_to_products', 'Terug naar producten': 'dawn.back_to_products'
    };
    function replaceLeafText(el) {
      if (el.children.length) return;
      var text = (el.textContent || '').trim();
      if (text && map[text]) el.textContent = t(map[text]);
    }
    document.querySelectorAll('.product-form__submit span').forEach(replaceLeafText);
    document.querySelectorAll('.shopify-payment-button span').forEach(replaceLeafText);
    document.querySelectorAll('.product-form span, .product span, .price span, label').forEach(replaceLeafText);
    document.querySelectorAll('.share-button span, .share-button__text, [id*="Share"] span').forEach(replaceLeafText);

    var productPage = document.querySelector('.product, [id*="ProductInfo"]');
    if (!productPage) return;
    var colonMap = { 'Kleur:': 'dawn.colour', 'Colour:': 'dawn.colour', 'Color:': 'dawn.colour' };
    var partialMap = {
      'worden berekend bij de checkout.': 'dawn.shipping_calc',
      'calculated at checkout.': 'dawn.shipping_calc',
      'in winkelwagen)': 'dawn.in_cart_paren',
      'in cart)': 'dawn.in_cart_paren',
      'Ga direct naar productinformatie': 'dawn.skip_to_info',
      'Skip to product information': 'dawn.skip_to_info',
      'openen in modaal': 'dawn.open_modal',
      'open in modal': 'dawn.open_modal'
    };
    var walker = document.createTreeWalker(productPage, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.trim();
      if (!text) continue;
      if (map[text]) { node.nodeValue = node.nodeValue.replace(text, t(map[text])); continue; }
      for (var ck in colonMap) {
        if (text === ck) { node.nodeValue = node.nodeValue.replace(ck, t(colonMap[ck]) + ':'); break; }
      }
      for (var pk in partialMap) {
        if (text.indexOf(pk) !== -1) { node.nodeValue = node.nodeValue.replace(pk, t(partialMap[pk])); break; }
      }
    }
  }

  /* ---------- Dawn product description/title i18n swap ------------------- */
  function overrideDawnDescription() {
    var descEN = document.getElementById('mb-desc-en');
    var descEl = document.getElementById('mb-desc-content');
    if (descEl) {
      if (!descEl.getAttribute('data-nl-saved')) {
        descEl.setAttribute('data-nl-saved', descEl.innerHTML);
      }
      if (state.lang === 'en' && descEN) {
        descEl.innerHTML = descEN.innerHTML;
      } else {
        descEl.innerHTML = descEl.getAttribute('data-nl-saved');
      }
    }
    var titleEN = document.getElementById('mb-title-en');
    var titleEl = document.querySelector('.product__title h1, h1.product__title');
    if (titleEl) {
      if (!titleEl.getAttribute('data-nl')) {
        titleEl.setAttribute('data-nl', titleEl.textContent);
      }
      if (state.lang === 'en' && titleEN) {
        titleEl.textContent = titleEN.textContent;
      } else {
        titleEl.textContent = titleEl.getAttribute('data-nl');
      }
    }
  }

  /* ---------- Dawn cart-drawer text override ----------------------------- */
  function overrideDawnCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var map = {
      'Je winkelwagen': 'dawn.cart_title', 'Your cart': 'dawn.cart_title',
      'PRODUCT': 'dawn.product', 'Product': 'dawn.product',
      'TOTAAL': 'dawn.total_col', 'Total': 'dawn.total_col', 'Totaal': 'dawn.total_col',
      'Subtotaal': 'dawn.subtotal', 'Subtotal': 'dawn.subtotal',
      'Geschat totaal': 'dawn.estimated_total', 'Estimated total': 'dawn.estimated_total',
      'Afrekenen': 'dawn.checkout', 'Check out': 'dawn.checkout',
      'Je winkelwagen is leeg': 'dawn.empty', 'Your cart is empty': 'dawn.empty',
      'Verder winkelen': 'dawn.continue', 'Continue shopping': 'dawn.continue',
      'Verwijderen': 'dawn.remove', 'Remove': 'dawn.remove',
      'Terugkeren naar winkel': 'dawn.return_shop', 'Return to shop': 'dawn.return_shop',
      'Heb je een account?': 'dawn.have_account', 'Have an account?': 'dawn.have_account',
      'Log in': 'dawn.login', 'Inloggen': 'dawn.login',
      'om sneller af te rekenen.': 'dawn.faster_checkout', 'to check out faster.': 'dawn.faster_checkout',
      'Bezig met laden...': 'dawn.loading', 'Loading...': 'dawn.loading',
      'BTW (21%)': 'dawn.tax_line', 'Tax (21%)': 'dawn.tax_line'
    };
    var taxMap = {
      'Belastingen inbegrepen. Kortingen en verzending worden bij de checkout berekend.': 'dawn.tax_note',
      'Taxes included. Discounts and shipping calculated at checkout.': 'dawn.tax_note',
      'Tax included. Discounts and shipping calculated at checkout.': 'dawn.tax_note'
    };
    function walkText(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue.trim();
        if (map[text]) node.nodeValue = t(map[text]);
        if (taxMap[text]) node.nodeValue = t(taxMap[text]);
      }
    }
    walkText(drawer);
    var observer = new MutationObserver(function () { walkText(drawer); });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  /* ---------- description + specs tabs --------------------------------- */
  function initDetailTabs() {
    var tabs = document.getElementById('mb-dtabs');
    if (!tabs) return;
    var btns = tabs.querySelectorAll('.mb-dtabs__btn');
    btns.forEach(function (btn) {
      btn.onclick = function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var which = btn.getAttribute('data-dtab');
        document.querySelectorAll('.mb-dcol').forEach(function (col) {
          col.classList.toggle('is-active', col.id === 'mb-dtab-' + which);
        });
      };
    });
    var first = document.getElementById('mb-dtab-desc');
    if (first) first.classList.add('is-active');
  }

  /* ---------- registration form validation ------------------------------- */
  function initRegValidation() {
    var form = document.querySelector('#mb-panel-register form');
    if (!form) return;

    var validators = {
      required: function (v) { return v.trim().length > 0; },
      email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); },
      password: function (v) { return v.length >= 5; },
      password_confirm: function (v) {
        var pass = document.getElementById('mb-reg-pass');
        return v.length > 0 && pass && v === pass.value;
      },
      kvk: function (v) { return v === '' || /^\d{8}$/.test(v); },
      btw: function (v) { return v === '' || /^[A-Z]{2}\d{9}B\d{2}$/i.test(v); },
      postcode: function (v) { return v === '' || /^\d{4}\s?[A-Za-z]{2}$/.test(v) || /^\d{4,5}$/.test(v); },
      phone: function (v) { return v === '' || /^[\d\s\+\-\(\)]{7,}$/.test(v); }
    };

    function check(input) {
      var rule = input.getAttribute('data-validate');
      if (!rule || !validators[rule]) return;
      var val = input.value;
      if (val === '' && !input.required) {
        input.classList.remove('is-valid', 'is-invalid');
        return;
      }
      var ok = validators[rule](val);
      input.classList.toggle('is-valid', ok);
      input.classList.toggle('is-invalid', !ok);
    }

    form.querySelectorAll('[data-validate]').forEach(function (inp) {
      inp.addEventListener('input', function () { check(inp); });
      inp.addEventListener('blur', function () { check(inp); });
    });

    var passInput = document.getElementById('mb-reg-pass');
    var confirmInput = document.getElementById('mb-reg-pass-confirm');
    if (passInput && confirmInput) {
      passInput.addEventListener('input', function () {
        if (confirmInput.value) check(confirmInput);
      });
    }

    form.addEventListener('submit', function (e) {
      if (confirmInput && passInput && confirmInput.value !== passInput.value) {
        e.preventDefault();
        confirmInput.classList.add('is-invalid');
        confirmInput.focus();
      }
    });
  }

  /* ---------- boot ------------------------------------------------------ */
  function boot() {
    if (!MB.products) { console.warn('MB data not loaded'); return; }
    initHeader();
    var checkoutBtn = document.getElementById('mb-cart-checkout');
    if (checkoutBtn) {
      checkoutBtn.onclick = function () { window.location.href = '/checkout'; };
    }
    initForms();
    initBackToTop();
    initRegToggle();
    initRegValidation();
    initDetailTabs();
    initPriceAnimation();
    renderAll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  MB.setLang = setLang;
  MB.renderAll = renderAll;
})();
